import { render, staticRenderFns } from "./signing.vue?vue&type=template&id=0ff4b0f7&scoped=true&"
import script from "./signing.vue?vue&type=script&lang=js&"
export * from "./signing.vue?vue&type=script&lang=js&"
import style0 from "./signing.vue?vue&type=style&index=0&id=0ff4b0f7&scoped=true&lang=css&"
import style1 from "./signing.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff4b0f7",
  null
  
)

export default component.exports